import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { IdHandoverRecordsState, typeHandoverRecordFilters } from 'model/dashboardHandoverRecord/dHandoverRecordReducer'
import {
    dHRecordSetDetailItemAC,
    dHRecordSetDataSagaAC,
    dHRecordSetFiltersAC,
    dHRecordSetPageNumberAC,
    dHRecordClearFiltersAC, dHRecordSetItemsForPageAC
} from 'model/dashboardHandoverRecord/dHandoverRecordActionCreators'
import { useInputChange } from 'hooks/useInputChange'
import { ViewDataHandoverRecordInfo } from './ViewComponent'
import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard'


// Type
export type typeDataHandoverRecords = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataHandoverRecordsRowActions = { title: JSX.Element, action: (id: string) => void }[]


// Component
export const DataHandoverRecords: React.FC<typeDataHandoverRecords> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // DateFilter
    const [isActiveFilters, setIsActiveFilters] = useState(false)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dHRecord: IdHandoverRecordsState }) => state.dHRecord.filters)


    // Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dHRecord: IdHandoverRecordsState }) => state.dHRecord.pagination),
        onGoToPage: (id: any) => dispatch(dHRecordSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dHRecordSetItemsForPageAC(itemsPerPage))

    }

    // Did mount & Did unmount
    useEffect(() => {
        return () => {
            dispatch(dHRecordClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dHRecordSetDataSagaAC(filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }))
        // eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ])

    // Search panel
    const searchStoreName = useSelector((state: { dHRecord: IdHandoverRecordsState }) => state.dHRecord.filters.storeName?.trim())
    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchStoreName || '')

    const onClearSearch = () => {
        dispatch(dHRecordSetFiltersAC({ storeName: null }))
        setSearchValue('')
    }
    const onEnterSearch = () => {
        const filters: typeHandoverRecordFilters = {
            storeName: searchValue.trim(),
        }
        dispatch(dHRecordSetFiltersAC(filters))
    }

    // Popup details
    const [ openPopupDetails, setOpenPopupDetails ] = useState(false)

    // Make table item actions
    const rowsActions: typeDataHandoverRecordsRowActions = [
        {
            title: <Trans>Details</Trans>,
            action: (id: string) => {
                dispatch(dHRecordSetDetailItemAC(id))
                setOpenPopupDetails(true)
            }
        }
    ]


    return (
        <ViewDataHandoverRecordInfo

            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupDetails={ openPopupDetails }
            setOpenPopupDetails={ setOpenPopupDetails }


            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onClearSearch={ onClearSearch }
            onEnterSearch={ onEnterSearch }

            rowsActions={ rowsActions }

            pagination={ pagination }
            isActiveFilters={isActiveFilters}
            setIsActiveFilters={setIsActiveFilters}
        />
    )
}
